import React from 'react';
import { View } from 'react-native';

import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';

export type ModalContentLayoutProps = {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  content?: React.ReactNode;
  actions?: React.ReactNode[];
  testID?: string;
};

const useStyles = makeStyles((theme) => ({
  root: {},
  iconWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  icon: {
    marginTop: -35,
  },
  title: {
    marginTop: theme.spacing(2),
    color: theme.palette.base[900],
    textAlign: 'center',
  },
  subtitle: {
    marginTop: theme.spacing(2),
    color: theme.palette.grey[700],
    textAlign: 'center',
  },
  content: {
    marginTop: theme.spacing(2),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  actionGap: {
    height: theme.spacing(1.5),
  },
}));

export const ModalContentLayout: React.FC<ModalContentLayoutProps> = ({
  icon,
  title,
  subtitle,
  content,
  actions,
  testID,
}) => {
  const styles = useStyles();

  return (
    <View style={styles.root} testID={testID}>
      {icon && (
        <View style={styles.iconWrapper} testID="icon">
          <View style={styles.icon}>{icon}</View>
        </View>
      )}
      {title && (
        <Typography size="2xl" style={styles.title} testID="title">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography size="md" style={styles.subtitle} testID="subtitle">
          {subtitle}
        </Typography>
      )}
      {content && (
        <View style={styles.content} testID="content">
          {content}
        </View>
      )}
      {actions?.length ? (
        <View style={styles.actions} testID="actions">
          {actions.map((action, index) => {
            if (index === 0) {
              return (
                <React.Fragment key={`action-${index}`}>
                  {action}
                </React.Fragment>
              );
            }

            return (
              <React.Fragment key={`action-${index}`}>
                <View style={styles.actionGap} />
                {action}
              </React.Fragment>
            );
          })}
        </View>
      ) : null}
    </View>
  );
};
